<template>
  <div class="page-footer" :style="{ 'position': footerFixed?'fixed':'relatives'}">
    <div class="footer-info clearfix">
      <router-link to="/">
        <img src="@images/rebuild/logo.png" alt="absolut" class="footer-logo" />
      </router-link>
      <!-- <div class="footer-tips" @click="showQrCode"><span class="iconfont icon-wechat"></span>有问题？关注绝对伏特加官方微信！</div> -->
      <div class="footer-sponsor">
        <div class="foot-tips-img">
          <img src="~@static/funding/pc/foot_tips.png" alt="" />
        </div>
        
        <a href="https://weibo.com/absolutvodkachina?topnav=1&wvr=6&topsug=1&is_hot=1" target="_blank" class="item">
          <img src="@images/icon_weibo.png" alt="" />
        </a>
        <a href="https://absolut.tmall.com/?spm=a220o.1000855.1997427721.d4918089.bJLPsY" target="_blank" class="item">
          <img src="@images/icon_tmall.png" alt="" />
        </a>
        <a href="https://www.instagram.com/absolutvodka/" target="_blank" class="item">
          <img src="@images/icon_ins.png" alt="" />
        </a>

        <div class="wechat-tips" @click="showQrCode"><span class="iconfont icon-wechat"></span>有问题？关注绝对伏特加官方微信!</div>
      </div>
      <div class="copyright pull-left">
        <div class="pull-left">
          <div><span class="text">保乐力加中国保留所有权利</span></div>
          <div>
            <span class="text white"><router-link to="/regulation">使用条款</router-link></span>
            <span class="text white"><router-link to="/protocol">隐私条款</router-link></span>
            <span class="text white">沪ICP备13027623号</span>
            <span class="text">保乐力加（中国）贸易有限公司 +86 21 2301 1000</span>
          </div>
        </div>
      </div>
    </div>
    

    <follow-modal
      v-if="followModalShow"
      :data="followModal"
      @close="followModalClose"
    ></follow-modal>
  </div>
</template>

<script>
import FollowModal from '@components/FollowModal'

export default {
  name: 'PageFooter',
  components: {
    FollowModal
  },
  data () {
    return {
      followModal: {
        title: '',
        subTitle: '',
        isLocalCode: '',
        hasBtn: '',
        btnText: '',
        btnLink: '',
        btnAction: '',
      },
      followModalShow: false,
      footerFixed: false
    }
  },
  methods: {
    showQrCode () {
      this.followModal.title = '关注绝对伏特加微信'
      this.followModal.subTitle = '扫描二维码，绝对给你爆料'
      this.followModal.isLocalCode = true
      this.followModal.hasBtn = false
      this.followModalShow = true
    },
    followModalClose () {
      this.followModalShow = false
      this.followModal.title = ''
      this.followModal.subTitle = ''
      this.followModal.isLocalCode = ''
      this.followModal.hasBtn = ''
      this.followModal.btnText = ''
      this.followModal.btnLink = ''
      this.followModal.btnAction = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.page-footer {
  display: none;
  margin-top: 100px;
  @include respond-to(desktop) {
    display: block;
    background:rgba(0,17,67, 0.7);
  }
  .footer-info {
    position: relative;
    width: 100%;
    padding: 0 16px;
    @include respond-to(desktop) {
      max-width: 1030px;
      margin: 0 auto;
      padding: 35px 0 20px;
    }
    .footer-logo {
      position: relative;
      z-index: 1;
      float: left;
      height: 40px;
      cursor: pointer;
      @include respond-to(desktop) {
        height:25px;
      }
    }
    .footer-tips {
      position: absolute;
      z-index: 0;
      top: 50%;
      left: 0;
      width: 100%;
      margin-top: -20px;
      text-align: center;
      font-weight: 500;
      font-size: 1.5rem;
      letter-spacing: -.02em;
      color: #fff;
      cursor: pointer;
      .iconfont {
        display: inline-block;
        margin: -2px 10px 0 0;
        vertical-align: middle;
        font-size: 3rem;
      }
    }
    .footer-sponsor {
      position: relative;
      z-index: 1;
      float: right;
      text-align: right;
      .item {
        display: inline-block;
        width: 25px;
        height: 25px;
        margin-left: 10px;
        & > img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .wechat-tips {
      font-size: 1.2rem;
      letter-spacing: 0.1em;
      color: rgba(255,255,255,0.5);
      cursor: pointer;
      .iconfont {
        display: inline-block;
        margin: -2px 10px 0 0;
        vertical-align: middle;
        font-size: 3rem;
      }
    }
    .foot-tips-img {
      width: 100%;
      display: block;
      margin-bottom: 5px;
      // height: 16px;
    }
  }
  .copyright {
    padding: 16px 0;
    text-align: left;
    font-size: 1.2rem;
    color: rgba(255, 255, 255, .5);
    position: absolute;
    left: 0;
    bottom: 15px;
    .text {
      margin-right: 20px;
    }
    
    a:hover {
      text-decoration: underline;
    }
    .white, a {
      color: rgba(255, 255, 255, .5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue